module.exports = __webpack_public_path__ + "static/img/cd_gs_disabled.c50625e3.png";